import { showToast } from 'components/ui-kit/toastr/Toastr'

export const showClipboardToast = () => showToast({ content: 'Copied page URL to clipboard!', type: 'success' })
